import {
  IEventChecklist,
  IEventChecklistItem,
} from '../entities/IEventChecklist';
import { httpClient } from './helper/httpClient';

export interface ICreateEventChecklistParams {
  name: string;
  items: IEventChecklistItem[];
}

export interface IUpdateEventChecklistParams {
  name: string;
  items: IEventChecklistItem[];
}

class EventChecklistService {
  private _baseURL = 'event-checklists';

  getAll(): Promise<IEventChecklist[]> {
    return httpClient.get<null, IEventChecklist[]>(this._baseURL);
  }

  create(data: ICreateEventChecklistParams): Promise<IEventChecklist> {
    return httpClient.post<null, IEventChecklist>(this._baseURL, { ...data });
  }

  update(id: string, data: IUpdateEventChecklistParams): Promise<void> {
    return httpClient.patch(`${this._baseURL}/${id}`, { ...data });
  }

  remove(id: string): Promise<void> {
    return httpClient.delete(`${this._baseURL}/${id}`);
  }
}

export default new EventChecklistService();
